// 报告模块
import { getReportHome } from '@/api/report'
import { getIndicatorByUserId, getPhysiologicalAgeByUserId, getPulseByUserId } from '@/api/indicator'
import { getHealthServices } from '@/api/health'

const state = {
  homeData: null,
  indicatorData: {},
  physiologicalAgeData: null,
  healthServicesData: null,
  pulseData: null
}

const mutations = {
  SET_HOME_DATA (state, data) {
    state.homeData = data
  },
  SET_INDICATOR_DATA (state, {
    type,
    data
  }) {
    state.indicatorData = {
      ...state.indicatorData,
      [type]: data
    }
  },
  SET_PHYSIOLOGICAL_AGE_DATA (state, data) {
    state.physiologicalAgeData = data
  },
  SET_HEALTH_SERVICES_DATA (state, data) {
    state.healthServicesData = data
  },
  SET_PULSE_DATA (state, data) {
    state.pulseData = data
  }
}

const actions = {
  // 获取报告首页数据
  async fetchHomeData ({ commit }, params) {
    try {
      const data = await getReportHome(params)
      commit('SET_HOME_DATA', data)
      if (data.bizUser) {
        console.info('bizUser', data.bizUser.id)
        commit('user/SET_USER_INFO', data.bizUser, { root: true })
        commit('user/SET_USER_ID', data.bizUser.id, { root: true })
      }
      return data
    } catch (error) {
      console.error('Failed to fetch home data:', error)
      throw error
    }
  },

  // 获取指标数据
  async fetchIndicatorData ({ commit }, {
    type,
    params
  }) {
    try {
      const data = await getIndicatorByUserId(type, params)
      commit('SET_INDICATOR_DATA', {
        type,
        data
      })
      return data
    } catch (error) {
      console.error(`Failed to fetch indicator data (${type}):`, error)
      throw error
    }
  },

  // 获取生理年龄数据
  async fetchPhysiologicalAgeData ({ commit }, params) {
    try {
      const data = await getPhysiologicalAgeByUserId(params)
      commit('SET_PHYSIOLOGICAL_AGE_DATA', data)
      return data
    } catch (error) {
      console.error('Failed to fetch physiological age data:', error)
      throw error
    }
  },

  // 获取健康服务数据
  async fetchHealthServicesData ({ commit }, params) {
    try {
      const data = await getHealthServices(params)
      commit('SET_HEALTH_SERVICES_DATA', data)
      return data
    } catch (error) {
      console.error('Failed to fetch health services data:', error)
      throw error
    }
  },

  async fetchPulseData ({ commit }, params) {
    try {
      const data = await getPulseByUserId(params)
      commit('SET_PULSE_DATA', data)
      return data
    } catch (error) {
      console.error('Failed to fetch pulse data:', error)
      throw error
    }
  },
}

const getters = {
  homeData: state => state.homeData,
  indicatorData: state => state.indicatorData,
  physiologicalAgeData: state => state.physiologicalAgeData,
  healthServicesData: state => state.healthServicesData,
  pulseData: state => state.pulseData,

  // 从首页数据中获取舌诊数据
  tongueData: state => {
    return state.homeData?.bizTongue || null
  },

  // 从首页数据中获取脉诊数据
  vesselData: state => {
    return state.homeData?.vesselDataVo || null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

